import React from "react";
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList, FR_SUFFIX, odsCallOutBoxs } from "../../entities/Constants";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import Utils from "../../utilities/Utils";
import { DialogBase } from "./DialogBase";

interface State {
    showConfirmationDialog: boolean;
    removeIndex: number;
} 

interface Props {
    ele: any;
    dialogVisible: boolean;
    isEng: boolean;
    callback: any;
}


export class DialogforRadioOptions extends DialogBase<Props,State> {
    dateTypeFieldList = [];

    constructor(props: Props) {
        super(props);
        this.state = {
            showConfirmationDialog: false,
            removeIndex: -1,
        };
    }


    render() {
        return (
            <>
                {/* @ts-ignore */}
                <Dialog
                    header={'Radio Button Options'}
                    visible={this.props.dialogVisible}
                    footer={this.renderFooter()}
                    style={{ width: '50vw' }}
                    onHide={() => this.props.callback(false)}
                >
                    {this.renderOptions()}
                </Dialog>
            </>
        )
    }

    renderOptions = () => {
        let html = [];

        html.push(
            <div>
                {this.hintExpansionTitleHtml()}

                {this.calloutBoxHtml()}

                {this.scriptHtml()}
             </div>
        )

        return html;
    }


    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />
            </div>
        );
    }
}
